import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService {

  private _baseUrl : string = "";
  private _controllerName :string = "";

  constructor(private _http : HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = "PaymentMethods"
  }

  // private getHeaders(): HttpHeaders{
  //   return new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${this.getToken()}`
  //   })
  // }

  insert(payload: any): Observable<any>{
    return this._http.post<any>(`${this._baseUrl}/${this._controllerName}`, payload).pipe(catchError(this.handleErrors))
  }

  update(id:number,payload: any): Observable<any>{
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${id}`, payload).pipe(catchError(this.handleErrors))
  }

  delete(id:number): Observable<any>{
    return this._http.delete<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  getAll(): Observable<any>{
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/`).pipe(catchError(this.handleErrors))
  }

  getById(id: number): Observable<any>{
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }


  private handleErrors(error: HttpErrorResponse){
    if(error.error instanceof ErrorEvent){
      console.log("Ocurrio un error", error.error.message);
    }else{
      console.log(`Ocurrio un error ${error.status}, ${error.error}`);
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }

}
